import { programTypeLabel } from './checkReconProgramType';

const paymentTransactionListHeaders = [
  {
    text: 'Payment#',
    value: 'paymentNumber',
    class: 'payment-transaction-table-headers-paymentNumber',
    id: 'paymentTransactionableheaderpaymentnumber',
  },
  {
    text: '',
    value: 'hasFiles',
    sortable: false,
    formatter: 'file',
    width: '4%',
    align: 'center',
  },
  {
    text: 'WKST',
    value: 'workstation',
    class: 'payment-transaction-table-headers-workstation',
    id: 'paymentTransactionableheaderworkstation',
  },
  {
    text: 'Date',
    value: 'payDate',
    formatter: 'shortDate',
    class: 'payment-transaction-table-headers-payDate',
    id: 'paymentTransactionableheaderpaydate',
  },
  {
    text: 'Total Amt',
    value: 'total',
    align: 'right',
    formatter: 'amount',
    sortable: false,
    class: 'payment-transaction-table-headers-totalamt',
    id: 'paymentTransactionableheadertotalamt',
  },
  {
    text: 'Check Amt',
    value: 'checkAmount',
    align: 'right',
    // formatter: 'amount',
    sortable: false,
    class: 'payment-transaction-table-headers-checkamt',
    id: 'paymentTransactionableheadercheckamt',
  },
  {
    text: 'Cash Amt',
    value: 'cashAmount',
    align: 'right',
    formatter: 'amount',
    sortable: false,
    class: 'payment-transaction-table-headers-cashamt',
    id: 'paymentTransactionableheadercashamt',
  },
  {
    text: 'Change',
    value: 'cashChange',
    align: 'right',
    formatter: 'amount',
    sortable: false,
    class: 'payment-transaction-table-headers-cashchange',
    id: 'paymentTransactionableheadercashchange',
  },
  {
    text: 'Other Amt',
    value: 'otherAmount',
    align: 'right',
    formatter: 'amount',
    sortable: false,
    class: 'payment-transaction-table-headers-otheramt',
    id: 'paymentTransactionableheaderotheramt',
  },
  {
    text: 'void?',
    value: 'void',
    formatter: 'flagToYorEmpty',
    class: 'payment-transaction-table-headers-void',
    id: 'paymentTransactionableheadervoid',
  },
];

const paymentDetailsTransactionListHeaders = [
  {
    text: 'Type', value: 'taxType', width: '8%', sortable: false,
  },
  {
    text: 'Tax Yr', value: 'taxYear', width: '5%', sortable: false,
  },
  {
    text: 'Tax ID', value: 'taxId', width: '5%', sortable: false,
  },
  {
    text: 'Tax Type', value: 'propertyTaxType', formatter: 'propertyTaxTypeShortCode', width: '5%', sortable: false, class: 'tax-type-col', cellClass: 'tax-type-col',
  },
  {
    text: 'Receipt#', value: 'reciept', width: '5%', sortable: false,
  },
  {
    text: 'Total Amt',
    value: 'total',
    align: 'right',
    formatter: 'amountOrZero',
    width: '10%',
    sortable: false,
  },
  {
    text: 'Payment Amt',
    value: 'amount',
    align: 'right',
    formatter: 'amountOrZero',
    width: '10%',
    sortable: false,
  },
  {
    text: 'Paid By', value: 'paidBy', sortable: false,
  },
  {
    text: 'Posted',
    value: 'posted',
    formatter: 'flagToYorEmpty',
    width: '10%',
    sortable: false,
  },
  {
    text: 'Void', value: 'void', formatter: 'flagToYorEmpty', width: '5%', sortable: false,
  },
];

const CommonDecalDialogHeaders = [
  {
    text: 'Tax Yr', value: 'taxYear', sortable: false,
  },
  {
    text: 'Tax ID', value: 'taxId', sortable: false,
  },
  {
    text: 'Decal', value: 'decal', sortable: false,
  },
];

const dialogTaxDetailsHeaders = [
  {
    text: '', value: 'selected', sortable: false, width: '50px',
  },
  {
    text: ' ', value: 'AIsVisible', sortable: false,
  },
  {
    text: 'Type', value: 'taxType', sortable: false,
  },
  {
    text: 'Tax Yr', value: 'taxYear', sortable: false,
  },
  {
    text: 'Tax ID', value: 'taxId', sortable: false,
  },
  {
    text: 'Owner Name', value: 'ownerName', sortable: false,
  },
  {
    text: 'Tax Type', value: 'propertyTaxType', formatter: 'propertyTaxTypeShortCode', sortable: false, class: 'tax-type-col', cellClass: 'tax-type-col',
  },
  {
    // Shares its slot with Cert No - dialogTaxDetails.getHeaders() rewrites this entry to
    // certNumber when showCertNumberOnPaymentScreen is on.
    text: 'Receipt', value: 'reciept', sortable: false,
  },
  {
    text: 'Tax Amt to Pay', value: 'taxAmt', sortable: false,
  },
  {
    text: 'Half', value: 'Half', sortable: false,
  },
  {
    text: 'Penalty Amt', value: 'penaltyAmt', sortable: false,
  },
  {
    text: 'Fees Total', value: 'FeesTotal', sortable: false,
  },
  {
    text: 'Total Pay', value: 'total', sortable: false,
  },
  {
    text: 'Posted', value: 'posted', sortable: false,
  },
  {
    text: 'Protest', value: 'protest', sortable: false,
  },
  {
    text: 'Void', value: 'void', sortable: false,
  },
  { text: 'Actions', value: 'actions', sortable: false },
];

const ccPayemntsHeaders = [
  { text: 'CC Date', value: 'paymentDate', formatter: 'shortDate' },
  { text: 'Business Date', value: 'systemDate', formatter: 'shortDate' },
  { text: 'Paid Date', value: 'paidClearedDate', formatter: 'shortDate' },
  { text: 'Payment Trans#', value: 'paymentNo' },
  { text: 'Taxpayer Name', value: 'paidBy' },
  {
    text: 'Payment Amount', value: 'amountPaid', align: 'right', formatter: 'amount',
  },
  { text: 'Payment Type', value: 'specialPaymentType' },
  { text: 'Payment Source', value: 'modeOfPayment' },
  { text: 'Transaction ID', value: 'transactionId', formatter: 'voidTransactionId' },
];
const checkReconcilationHeaders = [
  { text: 'Wkst', value: 'workstation', sortable: false },
  { text: 'Payment#  ', value: 'paymentNumber', sortable: false },
  {
    text: 'Type', value: 'programType', formatter: 'customMethod', methodDefinition: programTypeLabel, sortable: false,
  },
  { text: 'Check# ', value: 'checkNumber', sortable: false },
  { text: 'Paid By ', value: 'paidBy', sortable: false },
  {
    text: 'Amount', value: 'amount', align: 'right', formatter: 'amount', sortable: false,
  },
];
const feeTableHeaders = [
  { text: 'Fee#', value: 'feeNumber' },
  { text: 'Description', value: 'feeDescription', width: '300' },
  { text: 'Amount', value: 'feeAmount' },
];

const paymentsAuditheaders = [
  { text: 'Wkst #', value: 'workstation' },
  { text: 'Business Date', value: 'businessdate', formatter: 'shortDate' },
  { text: 'Payment#  ', value: 'paymentNumberAudit' },
  { text: 'System', value: 'system' },
  { text: 'Approval Status ', value: 'approvalStatusForVisibility' },
  { text: 'Audit Summary ', value: 'auditSummary' },
];

const postPaymentsList = [
  { text: 'Date', value: 'payDate', formatter: 'shortDate' },
  { text: 'Payment#', value: 'paymentNumber' },
  { text: 'Wkst#', value: 'workstation' },
  { text: 'Tax Year ', value: 'taxYear' },
  { text: 'Tax Id  ', value: 'taxId' },
];

const postAdjList = [
  { text: 'Date', value: 'adjDate', formatter: 'shortDate' },
  { text: 'Tax Year ', value: 'taxYear' },
  { text: 'Tax Id  ', value: 'taxId' },
];

export {
  ccPayemntsHeaders,
  checkReconcilationHeaders, CommonDecalDialogHeaders, dialogTaxDetailsHeaders,
  feeTableHeaders, paymentDetailsTransactionListHeaders, paymentsAuditheaders, paymentTransactionListHeaders, postAdjList,
  // eslint-disable-next-line comma-dangle
  postPaymentsList
};
export default {};
